'use client';

import Link from 'next/link';

import { ListingItemType } from '@/slw/entities/home/home.model';

import { ProductItem } from './product-item';
import { HeadingTitleContent } from './heading-title-content';

interface FeaturedListingsProps {
  listings: ListingItemType[];
}

export function FeaturedListings({ listings = [] }: FeaturedListingsProps) {
  return (
    <section>
      <HeadingTitleContent title='Featured Listings' />
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-6'>
        {listings.map((item, idx) => (
          <ProductItem key={`${item.id}_${idx}`} item={item} />
        ))}
      </div>
      <Link
        href={'/search-results/all-year?premiumSpotlight=true'}
        className='view-all font-medium text-primary block mt-3'
      >
        See all Featured Listings
      </Link>
    </section>
  );
}
